// removed by extract-text-webpack-plugin
module.exports = {"root":"MhDC3yOxH8fBa_v3","project":"_30NCxHSjWjUGG5s0","editing":"_1_wmmybswM0sGLre","nodesAmount":"_2dSX52TYcHh2e3Fl","editableName":"_24UV8SqufoZuwclK","projectName":"Ct1O7JQ2VTTqbAPU","permissionIcon":"_1DczbQ0wAlQTPBDP"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectsListItem.pcss
// module id = 508
// module chunks = 1